import React, { useState, useEffect,useRef } from 'react';
import Alert from "@mui/material/Alert";
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from 'react-google-recaptcha';
import { sendOtp } from '../services/otpService'; 
const EmailVerification = ({ onNext }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [language, setLang] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [langError, setLangError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const recaptchaRef = useRef(null);

  const validateEmail = (email) => {
    const regex = /^[\w.-]+@([\w.-]+\.)+\w{2,4}$/;
    return regex.test(email);
  };

  useEffect(() => {
    const validateForm = () => {
      let valid = true;
      if (email === '') {
        setEmailError('Email is required.');
        valid = false;
      }else if (!validateEmail(email)) {
        setEmailError('Please enter a valid email address');
        valid = false;
      } else {
        setEmailError('');
      }
      if (language === '') {
        setLangError('Language is required.');
        valid = false;
      }else {
        setLangError('');
      }
      setIsFormValid(valid && recaptchaToken !== '');
    };

    validateForm();
  }, [email,language, recaptchaToken]);

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleNext = async () => {
    setIsSubmitted(true);

    if (!isFormValid) {
      setError(t('validation.validEmailFields'),);
      return;
    }

    if (!recaptchaToken) {
      setError('Please complete the reCAPTCHA verification.');
      return;
    }

    try {
      const response = await sendOtp(email,language, recaptchaToken);
      if (response) {
        onNext( email, language);
      } else {
        setError('Failed to verify reCAPTCHA. Please try again.');
      }
    } catch (error) {
      setError(error.message);
    }
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setRecaptchaToken('')
    }
  };
 

  return (
    <Container>
         {error && (
        <Alert
          severity="error"
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            margin: 6,
          }}
        >
          {error}
        </Alert>
      )}
      <Row className="justify-content-center mt-5">
        <Col md={6}>
          <h3 className='border-h3'>
          {t("emailVerification.title")}
        </h3>
          <p className='mark-message'>{t('header.mandatory')}</p>
          <Form>
            <Form.Group controlId="formEmail">
              <Form.Label>{t('emailVerification.email')} *</Form.Label>
              <Form.Control
                type="email"
                placeholder={t('emailVerification.emailText')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                isInvalid={isSubmitted && !!emailError}
              />
              <Form.Control.Feedback type="invalid">
              {t('validation.validEmail')}
              </Form.Control.Feedback>

              <Form.Label className='mt-2'> {t('emailVerification.language')} *</Form.Label>
              <Form.Control className="form-select"
                as="select"
                value={language}
                onChange={(e) => setLang(e.target.value)}
                isInvalid={isSubmitted && !!langError}
                required
              >
                <option value="">{t("choose")}</option>
                <option value='AZ'>{t("emailVerification.AZ")}</option>
                <option value='EN'>{t("emailVerification.EN")}</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
              {t('validation.field')}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRecaptcha" className="mt-3">
              <ReCAPTCHA
              ref={recaptchaRef}
                sitekey="6LfBvuQpAAAAAMDIHg7BW5MhQO5pK_HQOAwk2hI3"
                onChange={handleRecaptchaChange}
              />
           
            </Form.Group>

            <Button
              variant="primary"
              onClick={handleNext}
              className="mt-3"
            >
              {t('emailVerification.next')}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default EmailVerification;